module.exports = __webpack_public_path__ + "img/gc5.68024796.png";